import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { SortDirection } from '@helsenorge/designsystem-react/components/Table';
import { Row } from './row';
export const sortIndexes = (columnKey, sortDir, data, useNumericSort, customSetSortValue) => {
    const sortIndexes = data.slice();
    sortIndexes.sort((a, b) => {
        let valueA;
        let valueB;
        const processedColNameValue = columnKey.split('.');
        if (processedColNameValue.length > 1) {
            const tempA = a[processedColNameValue[0]];
            const tempB = b[processedColNameValue[0]];
            valueA = tempA[processedColNameValue[1]];
            valueB = tempB[processedColNameValue[1]];
        }
        else {
            const columnValue = processedColNameValue[0];
            valueA = a[columnValue];
            valueB = b[columnValue];
        }
        if (!valueA) {
            valueA = '';
        }
        if (!valueB) {
            valueB = '';
        }
        if (customSetSortValue) {
            valueA = customSetSortValue(a, valueA, columnKey);
            valueB = customSetSortValue(b, valueB, columnKey);
        }
        const compareOptions = useNumericSort ? { numeric: true, sensitivity: 'base' } : {};
        let sortVal = 0;
        sortVal = valueA.localeCompare(valueB, 'nb', compareOptions);
        if (sortVal !== 0 && sortDir === SortDirection.desc) {
            sortVal = sortVal * -1;
        }
        return sortVal;
    });
    return sortIndexes;
};
export const isTableTwoDimensional = (data, columns) => {
    for (const rowData of data) {
        for (const column of columns) {
            if (Array.isArray(rowData[column.props.name])) {
                return true;
            }
        }
    }
    return false;
};
export const createLevel2Rows = (rowData, isExpanded, rowKey, columns) => {
    const rows = [];
    if (columns) {
        for (const column of columns) {
            if (!Array.isArray(rowData[column.props.name])) {
                continue;
            }
            if (!column.props.level2Cells) {
                continue;
            }
            const childRows = rowData[column.props.name];
            for (let j = 0; j < childRows.length; j++) {
                const childRowKey = `${rowKey}_${column.props.name}_${j}`;
                rows.push(React.cloneElement(column.props.level2Cells, {
                    key: childRowKey,
                    columns: columns,
                    rowData: childRows[j],
                    expandableRow: true,
                    expanded: isExpanded,
                    index: j,
                    total: childRows.length,
                }));
            }
        }
    }
    return rows;
};
export const createRows = (tableId, data, toggleExpandRow, getOrCreateRowRef, rowKeyColumnKey, highlightText, emptyContentText, emptyContentElement, columns, isTwoDimensional, expandableRow, expandedRows, className) => {
    const showDetailsText = 'Vis detaljer'; // TODO: Replace with resource values
    const hideDetailsText = 'Skjul detaljer'; // TODO: Replace with resource values
    const rows = [];
    for (let index = 0; index < data.length; ++index) {
        let rowKey = `row${index}`;
        const expandableRowKey = `expandableRow${index}`;
        const rowData = data[index];
        if (rowKeyColumnKey && rowData[rowKeyColumnKey]) {
            rowKey = rowData[rowKeyColumnKey];
        }
        const isExpanded = expandedRows ? !!expandedRows[expandableRowKey] : false;
        const isExpandableRow = expandableRow !== null || !!isTwoDimensional;
        rows.push(_jsx(Row, { tableId: tableId, ref: getOrCreateRowRef(rowKey), rowData: rowData, columns: columns, rowClasses: className, expandableRow: isExpandableRow, expanded: isExpanded, toggle: toggleExpandRow, highlightText: highlightText, showDetailsText: showDetailsText, hideDetailsText: hideDetailsText, rowKey: rowKey, expandableRowKey: expandableRowKey, isTwoDimensional: !!isTwoDimensional }, rowKey));
        const level2Rows = createLevel2Rows(rowData, isExpanded, rowKey, columns);
        rows.push(...level2Rows);
        if (expandableRow && React.isValidElement(expandableRow)) {
            const props = {
                colspan: columns ? columns.length + 1 : 0,
                rowData,
                key: expandableRowKey,
                open: isExpanded,
                toggle: toggleExpandRow,
                hideDetailsText: hideDetailsText,
                expandableRowKey,
                tableId: tableId,
            };
            rows.push(React.cloneElement(expandableRow, props));
        }
    }
    if (rows.length === 0) {
        // TODO: Replace fallback text with resource values
        const label = columns && columns[0] ? columns[0].props.title : '';
        rows.push(_jsx("tr", { children: _jsxs("td", { "data-label": label, colSpan: columns ? columns.length : 0, children: [_jsx("em", { children: emptyContentText }), emptyContentElement ? emptyContentElement : null] }) }, 'noContentRow'));
    }
    return rows;
};
const isColumn = (child) => child['type'].isExpandableRow || child['type'].isColumn;
export const checkChildren = (props) => {
    const columns = [];
    let expandableRow = null;
    React.Children.forEach(props.children, child => {
        if (child === null) {
            return;
        }
        if (isColumn(child)) {
            if (child['type'].isExpandableRow) {
                expandableRow = child;
            }
            if (child['type'].isColumn) {
                columns.push(child);
            }
        }
    });
    return { columns, expandableRow };
};
export const updateColumns = (props) => {
    const childrenProps = checkChildren(props);
    return childrenProps.columns;
};
